import { Box, useTheme } from '@mui/material';
import VerticalStyledToggleButtonGroup from 'app/shared-components/toggle-button-group/VerticalStyledToggleButtonGroup';
import { Dispatch, SetStateAction } from 'react';
import { SourceSystemOptions } from 'app/services/agave/agaveConstants';

export type ConnectToYourAccountingSystemProps = {
  value?: string;
  setValue: Dispatch<SetStateAction<string | undefined>>;
  disabled?: boolean;
};

function ConnectToYourAccountingSystem({ value, setValue, disabled }: ConnectToYourAccountingSystemProps) {
  const theme = useTheme();
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      gap="1rem"
      flexWrap="wrap"
      width="100%"
      sx={{
        backgroundColor: theme.palette.background.default,
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: 2,
        padding: 2.5,
        transition: 'box-shadow 0.2s ease-in-out',
        '&:hover': { boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)' },
      }}
    >
      <VerticalStyledToggleButtonGroup
        options={SourceSystemOptions}
        value={value}
        onChange={(_, value) => setValue(value)}
        disabled={disabled}
        fullWidth
      />
    </Box>
  );
}

export default ConnectToYourAccountingSystem;
